import { gql } from '@apollo/client';

import type {
  GetInsightInput,
  Insight,
  InsightEvaluation,
  InsightThumbsDownInput,
  InsightThumbsUpInput,
  MutationEvaluateInsightThumbsDownArgs,
  MutationEvaluateInsightThumbsUpArgs,
} from '../../__generated__/graphql';
import graphQLRequester from '../../request/GraphQLRequester';

export class GraphQLInsightsRequester {
  public getInsights = (input: GetInsightInput): Promise<Insight[]> =>
    graphQLRequester
      .query<{ insights: Insight[] }>({
        query: gql`
          query GetInsights($input: GetInsightInput!) {
            insights(input: $input) {
              id,
              createdAt,
              fleetId,
              category,
              vehicle {
                id,
                licensePlate,
                model {
                  brand,
                  name
                }
              },
              driver {
                id,
                name,
              },
              insightText,
              seen,
              group {
                id,
                name,
                path
              },
              impact,
              action,
            }
          }
        `,
        variables: { input },
      })
      .then((result) => result.insights);

  public evaluateInsightThumbsDown = (input: InsightThumbsDownInput): Promise<InsightEvaluation> =>
    graphQLRequester
      .mutate<{ evaluateInsightThumbsDown: InsightEvaluation }, MutationEvaluateInsightThumbsDownArgs>({
        mutation: gql`
        mutation EvaluateInsightThumbsDown($input: InsightThumbsDownInput!) {
          evaluateInsightThumbsDown(input: $input) {
            id,
            insight {
              id
            },
            spanId,
            traceId,
            thumbUp,
            thumbDown,
            comment,
          }
        }
    `,
        variables: {
          input,
        },
      })
      .then((result) => result.evaluateInsightThumbsDown);

  public evaluateInsightThumbsUp = (input: InsightThumbsUpInput): Promise<InsightEvaluation> =>
    graphQLRequester
      .mutate<{ evaluateInsightThumbsUp: InsightEvaluation }, MutationEvaluateInsightThumbsUpArgs>({
        mutation: gql`
            mutation EvaluateInsightThumbsUp($input: InsightThumbsUpInput!) {
              evaluateInsightThumbsUp(input: $input) {
                id,
                insight {
                  id
                },
                spanId,
                traceId,
                thumbUp,
                thumbDown,
                comment,
              }
            }
        `,
        variables: {
          input,
        },
      })
      .then((result) => result.evaluateInsightThumbsUp);
}

export default GraphQLInsightsRequester;
